module.exports = __webpack_public_path__ + "img/scroll-down.aa160634.svg";